import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AdministrativeFeeCatalogDto } from '../models/administrativefeecatalogdto';
import { PaginationFeaturesDto } from '../models/paginationfeaturesdto';
import { AppConfigService } from './core/appConfig.service';

@Injectable({
    providedIn: 'root'
})
export class AdministrativeFeeCatalogService {

    constructor(private http: HttpClient, private configService:AppConfigService) { }

    private url_catalog_getAll = '/configuration/management-fee-catalog/getAll';
    private url_catalog_filter = '/configuration/management-fee-catalog/filter/';
    private url_catalog_insert = '/configuration/management-fee-catalog/insert';
    private url_catalog_update = '/configuration/management-fee-catalog/update/'

    getAllCatalogs(pageRequest: PaginationFeaturesDto): Observable<any> {
        const params = new HttpParams()
            .set('page', pageRequest.page)
            .set('sizePage', 50)
            .set('orderField', 'codeAdministrativeFeeCatalog')
            .set('order', pageRequest.order);
        return this.http.get<any>(`${this.configService.apiUrl}${this.url_catalog_getAll}?${params}`).pipe(
            map(response => { return response; }));
    };

    getCatalogById(id: number): Observable<AdministrativeFeeCatalogDto> {
        return this.http.get<AdministrativeFeeCatalogDto>(`${this.configService.apiUrl}${this.url_catalog_filter}${id}`).pipe(
            map(response => new AdministrativeFeeCatalogDto(response))
        );
    }

    insertCatalog(catalog: AdministrativeFeeCatalogDto): Observable<AdministrativeFeeCatalogDto> {
        return this.http.post<AdministrativeFeeCatalogDto>(`${this.configService.apiUrl}${this.url_catalog_insert}`, catalog).pipe(
            map(response => new AdministrativeFeeCatalogDto(response))
        );
    }

    updateCatalog(actionBoolean: boolean, catalog: AdministrativeFeeCatalogDto): Observable<AdministrativeFeeCatalogDto> {
        return this.http.put<AdministrativeFeeCatalogDto>(`${this.configService.apiUrl}${this.url_catalog_update}${actionBoolean}`, catalog).pipe(
            map(response => new AdministrativeFeeCatalogDto(response))
        );
    }
}